import SendIntentAndroid from 'react-native-send-intent';
import {
  ANDROID_SETTINGS_CONSTANTS,
  getAndroidSettingsConstant,
} from './getAndroidSettingsConstant';

export const openSystemSettings = (settingsName: ANDROID_SETTINGS_CONSTANTS) =>
  SendIntentAndroid.openSettings(getAndroidSettingsConstant(settingsName));

export const openMainSystemSettings = () =>
  openSystemSettings(ANDROID_SETTINGS_CONSTANTS.MAIN);
